import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
  ADD_CARD, CHECKOUT,
  DASHBOARD,
} from 'constants/routes';
import MainLayout from 'components/Layout/Main';
import Dashboard from '../Dashboard';
import AddCardAdyen from '../AddCard';
import Checkout from '../Checkout';

function PublicLayout() {
  return (
    <MainLayout readyLayout>
      <Switch>
        <Route path={ADD_CARD} component={AddCardAdyen} />
        <Route path={CHECKOUT} component={Checkout} />
        <Route path={DASHBOARD} component={Dashboard} />
        <Redirect from="*" to="/" />
      </Switch>
    </MainLayout>
  );
}

export default PublicLayout;
